import { BulkUpdateDigitalWalletsRequest } from "@/models/digital.wallet";
import digitalWalletStore from "@/stores/digital.wallet.store";
import {
    Backdrop,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import { FC, useState } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-icon.svg";
import DialogComponentStyled from "../styled/dialog.component.styled";
import BulkWalletsUpdateStepper from "./bulk.wallets.update.stepper";

export interface IBulkWalletsUpdateDialogTitle {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BulkWalletsUpdateDialogTitle(props: IBulkWalletsUpdateDialogTitle) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 0 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

interface IBulkWalletsUpdateDialog {
    open: boolean;
    handleClose: () => void;
}

const BulkWalletsUpdateDialog: FC<IBulkWalletsUpdateDialog> = (props: IBulkWalletsUpdateDialog) => {
    const { open, handleClose } = props;
    const rows = digitalWalletStore.walletSelectionModel;
    const request = new BulkUpdateDigitalWalletsRequest();
    digitalWalletStore.setBulkUpdateDigitalWalletsRequest({
        ...request,
        digitalWallets: rows,
    });
    return (
        <Box>
            <DialogComponentStyled
                sx={{
                    zIndex: "1050",
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BulkWalletsUpdateDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                ></BulkWalletsUpdateDialogTitle>
                <DialogContent>
                    <BulkWalletsUpdateStepper closeDialog={handleClose}></BulkWalletsUpdateStepper>
                </DialogContent>
            </DialogComponentStyled>
        </Box>
    );
};

export default BulkWalletsUpdateDialog;
